import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import PerformanceReviewReview from './PerformanceReviewReview';
import Employee from 'main/stores/employees/Employee';
import _ from 'lodash';
import {calendarDate} from 'shared/tools';
import {auth} from 'main/tools';

class PerformanceReviewReviewee extends DomainObject {
  @observable id;
  @observable reviews = [];
  @observable employee;
  @observable reviewManager;
  @observable reviewers;
  @observable dueDate;
  @observable launchDate;
  @observable scheduled;

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      reviewManager: Employee,
      reviewManagerEmployees: [Employee],
      reviews: [PerformanceReviewReview],
      reviewers: [Employee],
      _dates: ['dueDate', 'launchDate']
    });
  }

  @computed get dueDateView() {
    return calendarDate(this.dueDate);
  }

  @computed get launchDateView() {
    return calendarDate(this.launchDate);
  }

  @computed get currentEmployeeManagerReview() {
    return _.find(this.reviews, (review) => 
      review.isManagerReview && review.reviewer?.id == auth.employee.id
    );
  }

  @computed get managerReview() {
    return _.find(this.reviews, r => r.type.kind === 'manager');
  }

  @computed get peerReviews() {
    return _.chain(this.reviews)
      .filter(r => r.type.kind === 'peer')
      .value();
  }

  @computed get managerReviewer() {
    return _.get(this.managerReview, 'reviewer');
  }

  @computed get peerReviewers() {
    return _.map(this.peerReviews, 'reviewer');
  }

  @computed get selfReview() {
    return _.find(this.reviews, r => r.type.kind === 'self');
  }

  @computed get selfReviewer() {
    return _.get(this.selfReview, 'reviewer') || [];
  }

  @computed get selfAndPeerReviewers() {
    return _.concat(this.selfReviewer, this.peerReviewers);
  }

  @computed get writeReviewsPath() {
    return `/reviews/${this.cycle.id}/reviewee/${this.id}/employee/${this.employee.id}/${this.employee.urlSlug}`;
  }
}

export default PerformanceReviewReviewee;
